import axios from "axios";

export default function ReceiptDeliverynoteInvoiceService(deliverynoteId, formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/receipt/" + deliverynoteId + "/create_invoice_from_delivery_note",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
